import React, { useEffect, useRef, useState } from 'react';
import styles from './FloatingTooltip.module.scss';
import cx from 'classnames';

const FloatingTooltip = ({ containerRef = null, label, offset = 15, className }) => {
  const [positionX, setPositionX] = useState(offset);
  const [init, setInit] = useState(true);

  const tooltipRef = useRef(null);

  useEffect(() => {
    if (containerRef) {
      if (containerRef.current && tooltipRef.current) {
        const { offsetLeft, offsetWidth, offsetParent } = tooltipRef.current;
        if (offsetLeft + offsetParent.offsetLeft + offsetWidth + offset > containerRef.current.offsetWidth) {
          setPositionX(0);
        } else {
          setPositionX(offset);
        }
        setInit(false);
      }
    } else {
      setInit(false);
    }
  }, []);

  return (
    <div
      ref={tooltipRef}
      className={cx(styles.titleTooltip, className)}
      style={{ opacity: init ? '0' : '1', right: `-${positionX}px` }}
    >
      <span>{label}</span>
    </div>
  );
};

export default FloatingTooltip;
